import { useGetIdentity, useListContext } from "ra-core";
import { ExportButton } from "@/components/admin/export-button";
import { List } from "@/components/admin/list";
import { ListPagination } from "@/components/admin/list-pagination";
import { SortButton } from "@/components/admin/sort-button";
import { Card } from "@/components/ui/card";

import { TopToolbar } from "../layout/TopToolbar";
import { MobileContent } from "../layout/MobileContent";
import MobileHeader from "../layout/MobileHeader";
import { useBcEnvironment } from "../misc/bcEnvironment";
import { CompanyEmpty } from "./CompanyEmpty";
import { CompanyListFilter } from "./CompanyListFilter";
import {
  CompanyListContent,
  CompanyListContentMobile,
} from "./CompanyListContent";

export const CompanyList = () => {
  const { identity } = useGetIdentity();
  const bcEnvironment = useBcEnvironment();
  if (!identity) return null;
  return (
    <List
      title={false}
      perPage={25}
      sort={{ field: "name", order: "ASC" }}
      filter={{ bc_environment: bcEnvironment }}
      actions={<CompanyListActions />}
      pagination={<ListPagination rowsPerPageOptions={[10, 25, 50, 100]} />}
    >
      <CompanyListLayout />
    </List>
  );
};

const CompanyListLayout = () => {
  const { data, isPending, filterValues } = useListContext();
  const hasFilters = filterValues && Object.keys(filterValues).length > 0;

  if (isPending) return null;
  if (!data?.length && !hasFilters) return <CompanyEmpty />;

  return (
    <div className="w-full flex flex-row gap-8">
      <CompanyListFilter />
      <div className="flex flex-col flex-1 gap-4">
        <Card className="py-0">
          <CompanyListContent />
        </Card>
      </div>
    </div>
  );
};

const CompanyListActions = () => (
  <TopToolbar>
    <SortButton fields={["name", "created_at", "nb_contacts"]} />
    <ExportButton />
  </TopToolbar>
);

export const CompanyListMobile = () => {
  const { identity } = useGetIdentity();
  const bcEnvironment = useBcEnvironment();
  if (!identity) return null;
  return (
    <List
      title={false}
      perPage={25}
      sort={{ field: "name", order: "ASC" }}
      filter={{ bc_environment: bcEnvironment }}
      pagination={<ListPagination rowsPerPageOptions={[10, 25]} />}
    >
      <CompanyListLayoutMobile />
    </List>
  );
};

const CompanyListLayoutMobile = () => {
  const { data, isPending, filterValues } = useListContext();
  const hasFilters = filterValues && Object.keys(filterValues).length > 0;

  return (
    <>
      <MobileHeader>
        <div className="flex flex-col gap-2 w-full">
          <CompanyListFilter />
        </div>
      </MobileHeader>
      <MobileContent>
        {!isPending && !data?.length && !hasFilters ? (
          <CompanyEmpty />
        ) : (
          <>
            <CompanyListContentMobile />
            <div className="flex justify-center mt-4">
              <ListPagination rowsPerPageOptions={[10, 25]} />
            </div>
          </>
        )}
      </MobileContent>
    </>
  );
};
